import {FC, useState} from 'react'
import clsx from 'clsx'
import {useQueryCDREntitiesRequest} from '../../hooks/useQueryCDRUsersRequest'
import {useAppDispatch, useAppSelector} from '../../../../hooks/redux'
import {updateQuery} from '../../slices/cdrFilterSlice'
import {shallowEqual} from 'react-redux'

type Props = {
  data: string
}

const CDROperator: FC<Props> = ({data}) => {
  const dispatch = useAppDispatch()
  const [hover, setHover] = useState(false)
  const {state} = useQueryCDREntitiesRequest()
  const query = useAppSelector((state) => state.cdrFilter.query, shallowEqual)

  const handleUpdateState = () => {
    if (query?.rules === undefined) {
      dispatch(updateQuery({search: data}))
    }
  }

  const user = state.users.find((u) => u.number === data)

  return (
    <div className='d-flex align-items-center'>
      <div
        className={clsx('d-flex justify-content-start flex-column me-3 text-gray-800', {
          'cursor-pointer': query?.rules === undefined,
        })}
        onClick={handleUpdateState}
      >
        <span
          className={clsx('', {'text-gray-600': hover})}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
        >
          {user?.name ? (
            <>
              <span className='small text-gray-900'>
                {user.name} ({data})
              </span>
            </>
          ) : (
            <>{data}</>
          )}
        </span>
      </div>
    </div>
  )
}

export {CDROperator}
